export var MuiOutlinedInput = {
  styleOverrides: {
    notchedOutline: function notchedOutline(_ref) {
      var theme = _ref.theme;
      return {
        ".Mui-error &": {
          borderWidth: 2
        }
      };
    }
  }
};
//# sourceMappingURL=MuiOutlinedInput.js.map